var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "form-group-material mb-1" }, [
    _c(
      "h4",
      { staticClass: "text-light-gray mb-2 mb-lg-0" },
      [
        _vm._v("\n    " + _vm._s(_vm.label)),
        _vm.required ? _c("input-required-indicator") : _vm._e(),
      ],
      1
    ),
    _vm._v(" "),
    _c("select", {
      ref: "timezoneSelect",
      staticClass: "material-input select-field form-control-filled",
      attrs: { id: "timezone-select", required: "", name: "timezone" },
    }),
    _vm._v(" "),
    _c("span", { staticClass: "bar" }),
    _vm._v(" "),
    _c(
      "label",
      { staticClass: "d-none", attrs: { for: "timezone-select" } },
      [
        _vm._v(_vm._s(_vm.label)),
        _vm.required ? _c("input-required-indicator") : _vm._e(),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }